export const ROUTE_PATHS = {
  HOME: "/",
  SERVICES: "/services",
  ABOUT: "/about",
  CONTACT: "/contact",
} as const;

export type ServiceCategory = "electronics" | "it-support";

export interface Service {
  id: string;
  title: string;
  description: string;
  category: ServiceCategory;
  iconName: string;
  priceRange: string;
  features: string[];
  onSiteAvailable: boolean;
  onCallAvailable: boolean;
}

export interface Technician {
  id: string;
  name: string;
  role: string;
  specialization: string[];
  image: string;
  rating: number;
  reviewsCount: number;
  experienceYears: number;
}

export interface ContactInfo {
  phone: string;
  email: string;
  address: string;
  workingHours: string;
  emergencyPhone: string;
  coverageAreas: string[];
}

export interface Testimonial {
  id: string;
  author: string;
  role: string;
  content: string;
  rating: number;
  image: string;
  date: string;
}

export function formatPhoneNumber(phone: string): string {
  const cleaned = ('' + phone).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return phone;
}